import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "../landing/Header";
import Footer from "../landing/Footer";
import CookieBanner from "../landing/CookieBanner";
import useSeo from "../landing/useSeo";
import { SITE } from "../landing/siteConfig";
import "../landing/landing.css";

const Register = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [passwordConfirm, setPasswordConfirm] = useState("");
    const [agree, setAgree] = useState(false);
    const [status, setStatus] = useState(null);
    const [agreeErr, setAgreeErr] = useState(false);

    const navigate = useNavigate();

    useSeo({
        title: `Регистрация — ${SITE.brand}`,
        description: `Зарегистрируйте личный кабинет ${SITE.brand} и начните получать юридические лиды.`,
        path: "/register",
        noindex: true,
    });

    const handleSubmit = (event) => {
        event.preventDefault();
        setStatus(null);
        setAgreeErr(false);

        if (password !== passwordConfirm) {
            setStatus({ type: "err", text: "Пароли не совпадают" });
            return;
        }
        if (!agree) {
            setAgreeErr(true);
            setStatus({ type: "err", text: "Нужно согласие на обработку персональных данных" });
            return;
        }

        const payload = { name, email, password };
        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify(payload),
        };

        fetch(`${process.env.REACT_APP_BACKEND}/api/register`, requestOptions)
            .then((response) => response.json())
            .then((data) => {
                if (data.error) {
                    setStatus({ type: "err", text: data.message });
                } else {
                    navigate("/login");
                }
            })
            .catch((error) => {
                setStatus({ type: "err", text: String(error) });
            });
    };

    return (
        <div className="lp">
            <Header />
            <section className="authsect">
                <div className="wrap">
                    <div className="auth-card auth-card--page">
                        <span className="eyebrow">Личный кабинет</span>
                        <h1 className="auth-card__title">Регистрация</h1>
                        <p className="auth-card__sub">
                            Заведите аккаунт за пару минут и начните получать лиды.
                        </p>
                        <form onSubmit={handleSubmit}>
                            <div className="form__row">
                                <label htmlFor="name">Имя</label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    autoComplete="name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="form__row">
                                <label htmlFor="email">Email</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    autoComplete="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="form__row">
                                <label htmlFor="password">Пароль</label>
                                <input
                                    type="password"
                                    id="password"
                                    name="password"
                                    autoComplete="new-password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="form__row">
                                <label htmlFor="password_confirm">Повторите пароль</label>
                                <input
                                    type="password"
                                    id="password_confirm"
                                    name="password_confirm"
                                    autoComplete="new-password"
                                    value={passwordConfirm}
                                    onChange={(e) => setPasswordConfirm(e.target.value)}
                                    required
                                />
                            </div>

                            <label className={`form__agree${agreeErr ? " has-err" : ""}`}>
                                <input
                                    type="checkbox"
                                    checked={agree}
                                    onChange={(e) => {
                                        setAgree(e.target.checked);
                                        setAgreeErr(false);
                                    }}
                                />
                                <span>
                                    Я даю{" "}
                                    <Link to="/consent" target="_blank" rel="noopener noreferrer">
                                        согласие на обработку персональных данных
                                    </Link>{" "}
                                    и ознакомлен с{" "}
                                    <Link to="/privacy" target="_blank" rel="noopener noreferrer">
                                        Политикой обработки персональных данных
                                    </Link>
                                </span>
                            </label>

                            <button type="submit" className="btn btn--lg btn--block">
                                Зарегистрироваться
                            </button>

                            {status && (
                                <p className={`form__status is-${status.type}`}>{status.text}</p>
                            )}
                        </form>
                        <p className="auth-card__switch">
                            Уже есть аккаунт? <Link to="/login">Войти</Link>
                        </p>
                    </div>
                </div>
            </section>
            <Footer />
            <CookieBanner />
        </div>
    );
};

export default Register;
